__turbopack_context__.v({
  "animate-bottom": "sheet-module-scss-module__j84tzG__animate-bottom",
  "container": "sheet-module-scss-module__j84tzG__container",
  "entered": "sheet-module-scss-module__j84tzG__entered",
  "entering": "sheet-module-scss-module__j84tzG__entering",
  "exited": "sheet-module-scss-module__j84tzG__exited",
  "exiting": "sheet-module-scss-module__j84tzG__exiting",
  "fill-container-width": "sheet-module-scss-module__j84tzG__fill-container-width",
  "initial": "sheet-module-scss-module__j84tzG__initial",
  "x-end": "sheet-module-scss-module__j84tzG__x-end",
  "x-start": "sheet-module-scss-module__j84tzG__x-start",
  "y-end": "sheet-module-scss-module__j84tzG__y-end",
  "y-start": "sheet-module-scss-module__j84tzG__y-start",
});
